<template lang="pug">
v-card.pa-4(style="height: 100%;")
  // Auth Modal
  SalesPersonModal(
    v-model="showSalespersonModal"
    color="primary"
    @submit="handleSellerCode"
    )
  AuthModal(
    v-model="showAuthModal"
    @submit="cancelTicket($event)"
    )
    //div(slot="content")
      v-layout(row wrap)
        v-flex.xs12.red--text(v-if="showAuthError") Código incorrecto
  v-form(ref="form")
    v-layout.px-1(wrap)
      v-flex.xs4.d-flex(style="align-items: center;").pt-4
        v-text-field(
          outline
          mask="N###################"
          :label="inputLabel"
          v-model="ticket"
          @keydown.enter="search"
          :rules="[v => !!v || 'Campo Obligatorio']"
          :disabled="loading"
          )
      v-flex.xs6.d-flex.pl-4
        v-radio-group(
          row
          v-model="type"
          :disabled="loading"
          )
          v-layout(wrap)
            v-flex.xs4.pb-3
              v-radio(label="Ticket de Venta" :value="1")
            v-flex.xs4
              v-radio(label="Ticket Venta Empleado" :value="2")
            v-flex.xs4
              v-radio(label="Cotización" :value="3")
            v-flex.xs4
              v-radio(label="Boleta" :value="4")
            v-flex.xs4
              v-radio(label="Factura" :value="5")
            v-flex.xs4(v-if="isCallCenter")
              v-radio(label="Solicitud de Despacho" :value="6")
      v-flex.xs2.pt-2
        div.d-flex(style="flex-direction: column")
        v-btn.secondary(
          block
          @click="search"
          :disabled="loading"
          small
          ) EDITAR
        v-btn.teal(
          block
          @click="search($event, true)"
          :disabled="loading"
          small
          :dark="!loading"
          ) REPLICAR
  v-layout(wrap)
    v-flex.xs6.md3.px-1
      v-btn.secondary(
        :outline="activeListType !== 1"
        :disabled="loading"
        @click="fetchRecent"
        block
        ) Últimos 20
    v-flex.xs6.md3.px-1 
      v-btn.secondary(
        :outline="activeListType !== 2"
        :disabled="loading"
        @click="fetchCanceled"
        block
        ) ANULADOS (DEL DÍA)
    v-flex.xs6.md3.px-1 
      v-btn.secondary(
        :outline="activeListType !== 3"
        :disabled="loading"
        @click="showSalespersonModal = true"
        block
        ) POR VENDEDOR (DEL DÍA)
    v-flex.xs6.md3.px-1 
      v-btn.secondary(
        :outline="activeListType !== 4"
        :disabled="loading"
        @click="fetchEmployeeSales"
        block
        ) TICKET EMPLEADO
  .table-area(style="height: calc(100vh - 380px); overflow-y: scroll;")
    v-data-table(
      :items="ticketList"
      :headers="headers"
      hide-actions
      disable-initial-sort
      )
      template(slot="items" slot-scope="props")
        tr
          td {{props.item.id}}
          td {{props.item.created_at}}
          td {{props.item.pos_sale_type_id === 1 ? 'Boleta' : 'Factura'}}
          td {{props.item.sl_customer ? props.item.sl_customer.alias_name : ''}}
          td {{props.item.sellerName}}
          td {{props.item.state}}
          td {{props.item.pos_sale_type_id === 1 ? props.item.ticket_total : props.item.invoice_total | mixFormatCurrency}}
          td.d-flex.justify-center(
            v-if="props.item.state === 'Vale Venta' && activeListType !== 4"
            )
            v-btn(
              icon
              @click="handlePrint(props.item)")
              v-icon(:color="colors.tertiary") print
            v-btn(
              icon
              @click="handleEdit(props.item)"
              )
              v-icon(:color="colors.success") edit
            v-btn(
              icon
              @click="handleEdit(props.item, true)")
              v-icon(color="blue-grey") send
            v-btn(
              icon
              @click="askTicketCancel(props.item)")
              v-icon(color="error") cancel
          td.d-flex.justify-center(v-else)
            v-btn(
              icon
              @click="handleEdit(props.item, true, false, activeListType === 4)")
              v-icon(color="blue-grey") send
            v-btn(
              icon
              v-if="activeListType === 4"
              @click="askTicketCancel(props.item)")
              v-icon(color="error") cancel
  v-snackbar.text-xs-center(
    bottom
    v-model="showSnackbar"
    :timeout="7000"
    color="error"
    )
    span.text-xs-center {{errorMessage}}
  v-snackbar.text-xs-center(
    bottom
    v-model="showSuccessSnackbar"
    :timeout="7000"
    color="success"
    )
    span.text-xs-center {{successMessage}}
</template>

<script>
import SalesPersonModal from '../../components/SimpleAuth/SalespersonModal'
import { mapActions, mapGetters } from 'vuex'
import headers from './headers'
import PosSale from '../../models/POS/PosSale'
import PosEmployeeSale from '../../models/POS/PosEmployeeSale.js'
import SlSaleQuotation from '../../models/Sale/SlSaleQuotation'
import {
    ticketIncludes,
    employeeSaleIncludes,
    quotationIncludes,
} from './includes'
import axios from 'axios'
import CurrencyUtils from '../../mixins/CurrencyUtils'
import AuthModal from '@/components/SimpleAuth/AuthModal'
import WhDispatchRequest from '../../models/Warehouse/WhDispatchRequest'

const initialState = () => ({
    ticket: '',
    type: 1,
    showCanceled: false,
    activeListType: 1,
    ticketList: [],
    loading: false,
    showSalespersonModal: false,
    headers,
    showSnackbar: false,
    showSuccessSnackbar: false,
    errorMessage: '',
    showAuthModal: false,
    itemToCancel: null,
    successMessage: '',
})

export default {
    name: 'ticket-list',
    components: { SalesPersonModal, AuthModal },
    mixins: [CurrencyUtils],
    data: () => initialState(),
    computed: {
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
            isCallCenter: 'isCallCenter',
        }),
        inputLabel() {
            if (this.type === 3) return 'N°Cotización'
            if (this.type === 4) return 'N°Boleta'
            if (this.type === 5) return 'N°Factura'
            if (this.type === 6) return 'N°Solicitud de Despacho'
            return 'N°Ticket'
        },
    },
    methods: {
        ...mapActions('AuthModule', ['authorizeSeller', 'authorizeSupervisor']),
        ...mapActions('CartModule', {
            setCartItems: 'setCartItems',
            setGlobalDiscount: 'setGlobalDiscount',
        }),
        ...mapActions('TransactionModule', {
            setTransactiontype: 'setTransactionType',
            setForcePrint: 'setForcePrint',
            setEditMode: 'setEditMode',
            setRecoveredStorePickup: 'setRecoveredStorePickup',
            setRecoveredOcNumber: 'setRecoveredOcNumber',
            setIsEditingDispatchRequest: 'setIsEditingDispatchRequest',
            setEditedDispatchRequestNumber: 'setEditedDispatchRequestNumber',
            setEditingOrigin: 'setEditingOrigin',
        }),
        ...mapActions('CustomerModule', {
            fetchCustomerData: 'fetchCustomerData',
            setActiveOffice: 'setActiveOffice',
        }),
        ...mapActions('EmployeeModule', {
            setEmployee: 'setEmployee',
            setValidEmployee: 'setValidEmployee',
        }),
        showError(e) {
            this.errorMessage =
                e && e.response && e.response.data && e.response.data.message
                    ? e.response.data.message
                    : e
            this.showSnackbar = true
        },
        showSuccess(message) {
            this.successMessage = message
            this.showSuccessSnackbar = true
        },
        searchDispatchRequest() {
            new WhDispatchRequest()
                .find(this.ticket)
                .then(
                    ({
                        sl_sale_invoice_id,
                        sl_sale_ticket_id,
                        pos_sale_id,
                        g_state_id,
                    }) => {
                        if (sl_sale_ticket_id || sl_sale_invoice_id) {
                            return this.showError(
                                'Esta solicitud de despacho ya fue facturada'
                            )
                        }
                        if (![23, 40].includes(g_state_id))
                            return this.showError(
                                'Sólo puede editar solicitudes por despachar, o en armado'
                            )
                        if (pos_sale_id) {
                            new PosSale()
                                .include(...ticketIncludes)
                                .find(pos_sale_id)
                                .then(sale => {
                                    if (!sale || !sale.id)
                                        return this.showError(
                                            'No se encontraron resultados'
                                        )
                                    if (this.type === 3) {
                                        sale.pos_detail_sales =
                                            sale.sl_detail_sale_quotations
                                        this.handleEdit(sale, true, true)
                                    } else if (this.type === 2) {
                                        sale.pos_detail_sales =
                                            sale.pos_detail_employee_sales
                                        this.handleEdit(sale, true, false, true)
                                    } else {
                                        this.handleEdit(
                                            sale,
                                            sale.g_state_id !== 17
                                        )
                                        if (
                                            this.type === 6 &&
                                            sale.g_state_id === 17
                                        ) {
                                            this.setIsEditingDispatchRequest(
                                                true
                                            )
                                            this.setEditedDispatchRequestNumber(
                                                this.ticket
                                            )
                                        }
                                    }
                                })
                                .catch(e => this.showError(e))
                                .finally(() => (this.loading = false))
                        }
                    }
                )
                .catch(e => this.showError(e))
        },
        search(e, replicateOnly = false) {
            if (e) {
                e.preventDefault()
                e.stopPropagation()
            }
            if (!this.$refs.form.validate()) return
            let mdl = null

            if (this.type === 6) return this.searchDispatchRequest()

            if (this.type === 4 || this.type === 5)
                return this.searchByDteNumber()

            switch (this.type) {
                case 1:
                    mdl = new PosSale().include(...ticketIncludes)
                    break
                case 2:
                    mdl = new PosEmployeeSale().include(...employeeSaleIncludes)
                    break
                case 3:
                    mdl = new SlSaleQuotation().include(...quotationIncludes)
                    break
                default:
                    mdl = null
            }

            if (!mdl) return

            this.loading = true

            mdl.find(this.ticket)
                .then(sale => {
                    if (!sale || !sale.id)
                        return this.showError('No se encontraron resultados')
                    if (this.type === 3) {
                        sale.pos_detail_sales = sale.sl_detail_sale_quotations
                        this.handleEdit(sale, true, true)
                    } else if (this.type === 2) {
                        sale.pos_detail_sales = sale.pos_detail_employee_sales
                        this.handleEdit(sale, true, false, true)
                    } else
                        this.handleEdit(
                            sale,
                            replicateOnly || sale.g_state_id !== 17
                        )
                })
                .catch(e => this.showError(e))
                .finally(() => (this.loading = false))
        },
        searchByDteNumber() {
            let route = this.ticketRoute(this.ticket)
            if (this.type === 5) route = this.invoiceRoute(this.ticket)
            axios
                .get(route)
                .then(res => {
                    let doc = res.data
                    // This reducer sum quantity of repeated products for multiticket sales
                    let detailReducer = (reduced, detail) => {
                        let index = reduced.findIndex(
                            r => r.wh_product_id === detail.wh_product_id
                        )
                        if (index !== -1) {
                            let product = reduced[index]
                            product.quantity =
                                parseFloat(product.quantity) +
                                parseFloat(detail.quantity)
                            reduced[index] = product
                        } else reduced.push(detail)
                        return reduced
                    }
                    if (this.type === 4) {
                        doc.pos_detail_sales = doc.sl_detail_sale_tickets.reduce(
                            detailReducer,
                            []
                        )
                        doc.pos_sale_type_id = 1
                        this.handleEdit(doc, true, false, false)
                    } else if (this.type === 5) {
                        doc.pos_detail_sales = doc.sl_detail_sale_invoices.reduce(
                            detailReducer,
                            []
                        )
                        doc.pos_sale_type_id = 2
                        this.handleEdit(doc, true, false, false)
                    }
                })
                .catch(e => this.showError(e))
                .finally(() => (this.loading = false))
        },
        invoiceRoute: docNumber => {
            return (
                process.env.VUE_APP_API_ROUTE +
                '/sl_sale_invoice/number/' +
                docNumber +
                '?include=sl_detail_sale_invoices.wh_product'
            )
        },
        ticketRoute: docNumber => {
            return (
                process.env.VUE_APP_API_ROUTE +
                '/sl_sale_ticket/number/' +
                docNumber +
                '?include=sl_detail_sale_tickets.wh_product'
            )
        },
        askTicketCancel(item) {
            this.itemToCancel = item
            this.showAuthModal = true
        },
        cancelEmployeeSale() {},
        cancelTicket(code) {
            this.loading = true
            this.authorizeSupervisor({ code })
                .then(() => {
                    let mdl = this.itemToCancel.pos_detail_employee_sales
                        ? PosEmployeeSale
                        : PosSale
                    new mdl({ id: this.itemToCancel.id })
                        .delete()
                        .then(r => {
                            if (this.activeListType === 1) this.fetchRecent()
                            if (this.activeListType === 2) this.fetchCanceled()
                            if (this.activeListType === 3) this.fetchBySeller()
                            if (this.activeListType === 4)
                                this.fetchEmployeeSales()
                            this.showSuccess('Ticket anulado exitosamente')
                        })
                        .catch(e => this.showError(e))
                        .finally((this.loading = false))
                })
                .catch(e => {
                    this.showError(e)
                    this.loading = false
                })
                .finally(() => (this.showAuthModal = false))
        },
        fetchTickets(state = null, seller) {
            this.loading = true
            let mdl = new PosSale()
                .include(...ticketIncludes)
                .orderBy('-updated_at')
            if (state) mdl.where('g_state_id', state)
            else mdl.whereIn('g_state_id', [17, 18])
            if (seller) mdl.where('g_seller_user_id', seller)
            if (state !== 17 || seller) {
                mdl.where('today', true)
                mdl.limit(-1)
            } else {
                mdl.limit(20)
            }
            mdl.get()
                .then(r => (this.ticketList = r.data.map(this.formatTicket)))
                .catch(e => this.showError(e))
                .finally(() => (this.loading = false))
        },
        fetchEmployeeSales() {
            this.loading = true
            new PosEmployeeSale()
                .include(...employeeSaleIncludes)
                .orderBy('-updated_at')
                .where('g_state_id', 17)
                .limit(-1)
                .get()
                .then(r => {
                    this.ticketList = r.data.map(this.formatTicket)
                    this.activeListType = 4
                })
                .catch(e => this.showError(e))
                .finally(() => (this.loading = false))
        },
        fetchRecent() {
            this.fetchTickets(17)
            this.activeListType = 1
        },
        fetchCanceled() {
            this.fetchTickets(18)
            this.activeListType = 2
        },
        fetchBySeller(sellerId) {
            this.fetchTickets(null, sellerId)
            this.activeListType = 3
        },
        handleSellerCode(code) {
            this.authorizeSeller({ code })
                .then(seller => {
                    this.fetchBySeller(seller.user.id)
                })
                .catch(e => this.showError(e))
                .finally(() => (this.showSalespersonModal = false))
        },
        formatTicket: row => {
            row.sellerName =
                row.g_seller_user.hr_employee.names +
                ' ' +
                row.g_seller_user.hr_employee.last_name1
            row.state = row.g_state.state
            return row
        },
        // copypasted from old ticketlist
        handlePrint: async function(sale) {
            let sl = { ...sale }
            await this.handleEdit(sl, true)
            let forcePrint = {
                barcode: sl.id,
                dateTime: sl.created_at,
                sale: sl,
            }
            this.setForcePrint(forcePrint)
        },
        handleEdit: async function(
            sale,
            noDestroy = false, // replicate on/off
            quotation = false,
            employee = false
        ) {
            this.dialogLoading = true
            if (sale.flag_store_pickup === false)
                this.setRecoveredStorePickup(true)
            else this.setRecoveredStorePickup(false)
            if (sale.pos_origin_sale_id && !noDestroy)
                this.setEditingOrigin(sale.pos_origin_sale_id)
            this.setTransactiontype(quotation ? 2 : sale.pos_sale_type_id)
            if ((sale.pos_sale_type_id === 2 || quotation) && !employee) {
                this.setTransactiontype(2)
                this.fetchCustomerData({
                    field: 'id',
                    value: sale.sl_customer_id,
                })
                    .then(console.log)
                    .catch(e => this.showError(e))
                this.setActiveOffice(sale.sl_customer_branch_offices_id)
            } else if (employee) {
                this.setTransactiontype(5)
                this.setEmployee(sale.g_employee_user.hr_employee)
                this.setValidEmployee(true)
            } else if (sale.pos_sale_type_id === 1 && sale.sl_customer_id) {
                this.fetchCustomerData({
                    field: 'id',
                    value: sale.sl_customer_id,
                })
                    .then(console.log)
                    .catch(e => this.showError(e))
                this.setActiveOffice(sale.sl_customer_branch_offices_id)
            } else {
                this.setTransactiontype(1)
            }
            if (sale.pos_detail_employee_sales && !sale.pos_detail_sales)
                sale.pos_detail_sales = sale.pos_detail_employee_sales
            let queryStr = sale.pos_detail_sales
                .reduce((acc, itm) => {
                    acc.push(itm.wh_product_id)
                    return acc
                }, [])
                .join()

            let includes = `sl_wholesale_discounts,wh_product_upc_code`
            let appends = `sale_prices,stocks,virtual_offer_price`
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/wh_product?filter[wh_product_ids]=` +
                `${queryStr}&include=${includes}&append=${appends}&get_all_results=true`
            let items = []
            try {
                items = await axios.get(route)
            } catch (e) {
                return this.showError(e)
            }

            items = items.data.data.map((newItem, idx) => {
                let item = sale.pos_detail_sales.find(
                    el => el.wh_product_id === newItem.id
                )
                newItem.quantity = parseFloat(item.quantity).toString()
                newItem.lineDiscount = {}
                newItem.lineDiscount.percentage_discount =
                    parseFloat(item.discount_or_charge_percentage) || null
                newItem.lineDiscount.unit_price_discount =
                    parseFloat(item.discount_or_charge_value) || null
                if (!newItem.sale_prices || !newItem.sale_prices.length) return
                let officePrice = newItem.sale_prices.find(
                    i => i.branch_office_id === this.branchOfficeID
                )
                if (officePrice) officePrice = parseInt(officePrice.sale_price)
                newItem.base_price = officePrice
                if (!item.price) item.price = officePrice
                else item.price = parseInt(item.price)
                const truncateAndRound = float => {
                    float = ('' + float).split('.')
                    if (float.length > 1) {
                        float = float[0] + '.' + float[1].charAt(0)
                    } else {
                        float = float[0]
                    }
                    return Math.round(float)
                }
                if (officePrice !== item.price) {
                    //check if offer price
                    if (newItem.sl_wholesale_discounts) {
                        let discounts = newItem.sl_wholesale_discounts
                            .filter(
                                item =>
                                    item.g_branch_office_id ===
                                    this.branchOfficeID
                            )
                            .sort((a, b) => {
                                if (a.quantity_discount < b.quantity_discount)
                                    return 1
                                if (a.quantity_discount > b.quantity_discount)
                                    return -1
                                return 0
                            })
                        if (discounts) {
                            newItem.availableWholesaleDiscounts = discounts
                        }
                        const discount = discounts.find(
                            dc => dc.quantity_discount <= newItem.quantity
                        )
                        if (discount) {
                            let discountAmount = discount.unit_price_discount
                            let invoiceDiscountAmount =
                                discount.unit_price_discount
                            if (!discountAmount || discountAmount == 0) {
                                discountAmount = truncateAndRound(
                                    (officePrice *
                                        discount.percentage_discount) /
                                        100
                                )
                                invoiceDiscountAmount = truncateAndRound(
                                    (officePrice *
                                        discount.percentage_discount) /
                                        100
                                )
                            }
                            if (
                                parseInt(item.price) ===
                                parseInt(officePrice - discountAmount)
                            ) {
                                newItem.discounted_price =
                                    newItem.sale_price - discountAmount
                                newItem.backend_invoice_price = truncateAndRound(
                                    newItem.sale_price - invoiceDiscountAmount
                                )
                                newItem.active_discount = discount
                            }
                        }
                    }
                    if (
                        !newItem.active_discount &&
                        (!newItem.virtual_offer_price ||
                            parseInt(
                                newItem.virtual_offer_price.offer_price
                            ) !== parseInt(item.price))
                    ) {
                        newItem.replaced_price = {}
                        newItem.replaced_price.original = officePrice
                        newItem.replaced_price.replaced = true
                        /*
                        newItem.sale_prices = newItem.sale_prices.map(s => {
                            s.sale_price = item.price
                            return s
                        })
                        */
                    }
                }
                if (
                    newItem.lineDiscount &&
                    newItem.lineDiscount.unit_price_discount &&
                    newItem.virtual_offer_price &&
                    newItem.virtual_offer_price.offer_price &&
                    parseInt(newItem.virtual_offer_price.offer_price) ===
                        parseInt(newItem.virtual_offer_price.sale_price) -
                            Math.round(
                                parseInt(
                                    newItem.lineDiscount.unit_price_discount
                                ) / newItem.quantity
                            )
                )
                    newItem.lineDiscount.unit_price_discount = null
                newItem.sale_price = item.price
                newItem.backend_invoice_price = item.price
                //newItem.default_warehouse = item.wh_warehouse_id
                //newItem.active_warehouse = item.wh_warehouse_id
                this.dialogLoading = false
                //newItem.virtual_offer_price = null
                newItem.availableWholesaleDiscounts = []
                let stock = newItem.stocks
                    .map(s => s.wh_warehouses)
                    .flat()
                    .find(w => w.wh_warehouse_id === item.wh_warehouse_id)
                if (!noDestroy && sale.pos_sale_product_stock_reservations) {
                    newItem.stocks = newItem.stocks.map(office => {
                        office.wh_warehouses = office.wh_warehouses.map(wh => {
                            let reservedStock = sale.pos_sale_product_stock_reservations.reduce(
                                (totalStock, reservation) =>
                                    reservation.wh_product_id === newItem.id &&
                                    reservation.wh_warehouse_id ===
                                        wh.wh_warehouse_id
                                        ? (totalStock += parseFloat(
                                              reservation.stock
                                          ))
                                        : totalStock,
                                0
                            )
                            if (reservedStock)
                                wh.logical_stock =
                                    parseFloat(wh.logical_stock) +
                                    parseFloat(reservedStock)
                            return wh
                        })
                        /*
                        office.wh_warehouses = office.wh_warehouses.map(wh => {
                            let stockReservation = sale.pos_sale_product_stock_reservations.find(
                                reservation =>
                                    reservation.wh_product_id === newItem.id &&
                                    reservation.wh_warehouse_id ===
                                        wh.wh_warehouse_id
                            )
                            if (stockReservation)
                                wh.logical_stock =
                                    parseFloat(wh.logical_stock) +
                                    parseFloat(stockReservation.stock)
                            return wh
                        })
                        */
                        return office
                    })
                    /*
                    stock.logical_stock =
                        parseInt(stock.logical_stock) +
                        parseInt(newItem.quantity)
                    newItem.active_warehouse = item.wh_warehouse_id
                    newItem.stock = stock.logical_stock
                    */
                } else if (stock && stock.logical_stock >= newItem.quantity) {
                    newItem.active_warehouse = item.wh_warehouse_id
                    newItem.stock = stock.logical_stock
                }
                /*
                newItem.stocks = newItem.stocks.map(s => {
                    if (s.wh_warehouses && s.wh_warehouses.length)
                        s.wh_warehouses = s.wh_warehouses.map(w => {
                            if (w.wh_warehouse_id === item.wh_warehouse_id)
                                w.logical_stock += parseFloat(item.quantity)
                            return w
                        })
                    return s
                })
                */
                return newItem
            })
            this.setCartItems(
                queryStr
                    .split(',')
                    .map(id => items.find(i => i.id === parseInt(id)))
            )
            if (!noDestroy) {
                this.setEditMode(sale.id)
            }
            if (sale.discount_or_charge_amount)
                this.setGlobalDiscount({
                    amount_discount: sale.discount_or_charge_amount,
                    percentage_discount: 0,
                })
            if (sale.discount_or_charge_percentage)
                this.setGlobalDiscount({
                    amount_discount: 0,
                    percentage_discount: sale.discount_or_charge_percentage,
                })
            this.$router.replace('/')
        },
    },
    created() {
        this.fetchRecent()
    },
}
</script>
